import React from 'react';
import { useAuth } from '../../context/AuthContext';
import './SessionWarningModal.scss';

interface SessionWarningModalProps {
  timeRemaining: number | null;
  onContinue: () => void;
}

const SessionWarningModal: React.FC<SessionWarningModalProps> = ({ 
  timeRemaining, 
  onContinue 
}) => {
  const { softLogout } = useAuth();

  const formatTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  return (
    <div className="session-warning-overlay">
      <div className="session-warning-modal">
        <div className="warning-icon">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 9V13M12 17H12.01M5.07183 19H18.9282C20.4678 19 21.4301 17.3333 20.6603 16L13.7321 4C12.9623 2.66667 11.0377 2.66667 10.2679 4L3.33975 16C2.56995 17.3333 3.53223 19 5.07183 19Z" 
              stroke="#F59E0B" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round"
            />
          </svg>
        </div>
        
        <h2 className="warning-title">Session Expiring Soon</h2>
        
        <p className="warning-message">
          Your session will expire due to inactivity in
        </p>
        
        {timeRemaining !== null && (
          <div className="time-display">
            {formatTime(timeRemaining)}
          </div>
        )}
        
        <p className="warning-submessage">
          Click continue to stay signed in
        </p>
        
        <div className="modal-actions">
          <button 
            className="btn-continue"
            onClick={onContinue}
          >
            Continue Session
          </button>
          
          <button 
            className="btn-logout"
            onClick={softLogout}
          >
            Logout Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default SessionWarningModal;